import { Injectable } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BehaviorSubject } from 'rxjs';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class PathsService {
    private _isPartnerPage: boolean;
    private _$portalId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _$baseLink: BehaviorSubject<string> = new BehaviorSubject<string>('/');

    constructor(
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService
    ) {}

    public initPathParameters() {
        this._isPartnerPage = this._configurationService.isPartnerPage();
        if (this._isPartnerPage) {
            const paths = window.location.pathname.split('/');
            const portalId = paths[2]?.toLowerCase();
            this._$portalId.next(portalId);
            this._$baseLink.next('/partner/' + portalId);
        }
    }

    public getHomeLink(): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/home';
        }
        return this._localizeRouterService.translateRoute('/home');
    }

    public getAccountLink(): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/account';
        }
        return this._localizeRouterService.translateRoute('/login');
    }

    public getCourseListLink(): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue();
        }
        return this._localizeRouterService.translateRoute('/courses');
    }

    public getTrainingAdvisorLink(): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue();
        }
        return this._localizeRouterService.translateRoute('/training-advisor');
    }

    public getCheckoutLink(): string | any {
        const _isPortal = this._configurationService.isPartnerPage();

        if (_isPortal) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                return '/partner/' + portalId + '/order-process';
            });
        } else {
            return this._localizeRouterService.translateRoute('/checkout');
        }
    }

    public getCheckoutLinkV2(): string | any {
        const _isPortal = this._configurationService.isPartnerPage();
        if (_isPortal) {
            const portalId = this._configurationService.portalId;
            return '/partner/' + portalId + '/order-process';
        } else {
            return this._localizeRouterService.translateRoute('/checkout');
        }
    }

    public getCourseDetailLink(id: string): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/course-detail/' + id;
        }
        return this._localizeRouterService.translateRoute('/course/' + id);
    }

    public getEventDetailLink(id: string): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/event-detail/' + id;
        }
        return this._localizeRouterService.translateRoute('/event/' + id);
    }

    public getBookingLink(id: string): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/booking/' + id;
        }
        return this._localizeRouterService.translateRoute('/booking/' + id);
    }

    public getAccountCourseDetailLink(id: string): string | any {
        if (this._isPartnerPage) {
            return this._$baseLink.getValue() + '/course-detail/' + id;
        }
        return this._localizeRouterService.translateRoute('/course/' + id);
    }

    public getAccountBookingDetailsLink(id: string): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/booking-details/' + id;
        }
        return this._localizeRouterService.translateRoute('/booking-details/' + id);
    }

    public getAccountPersonalDataLink(): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/personal-data';
        }
        return this._localizeRouterService.translateRoute('/personal-data');
    }

    public getAccountChangePasswordLink(): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/change-password/';
        }
        return this._localizeRouterService.translateRoute('/change-password');
    }

    public getForgotPasswordLink(): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/forgot-password';
        }
        return this._localizeRouterService.translateRoute('/forgot-password');
    }

    public getResetPasswordLink(): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/reset-password';
        }
        return this._localizeRouterService.translateRoute('/account/reset-password');
    }

    getAccountCourseList(): string | any {
        if (this._isPartnerPage) {
            return this.getAccountLink() + '/courses-overview';
        }
        return this._localizeRouterService.translateRoute('/my-courses');
    }

    getContactLink(): string | any {
        return this._localizeRouterService.translateRoute('/contact-us');
    }
}
